export const PAGE_PATHS = {
  VLE_STATS: "/vle-stats",
  COUNTRY_STATS: "/country-stats",
  LEARNER: "/learner",
  LEARNER_REPORTS: "/learner-reports",
  PLACEMENT_PARTNERS: "/placement-partners",
  ADMINS: "/admins",
  UPLOADS: "/uploads",
  UPDATE_USER_COURSE_COMPLETION: "/uploads/course-completion",
  UPDATE_STATE_LIMIT: "/update-state-limit",
  DEFAULT: "/",
};
